import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { DataServiceService } from '../service/data-service.service';
import { ToastrService } from 'ngx-toastr';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from '../service/auth.service';

export const userHasAccessToClientGuard: CanActivateFn = (route: ActivatedRouteSnapshot): Observable<boolean> | boolean => {
  const auth = inject(AuthService);
  const dataService = inject(DataServiceService);
  const toastrService = inject(ToastrService);

  const user = auth.getUser();
  if (!user) {
    toastrService.error('You do not have access to the information of this client', 'Access Error');
    return false;
  }

  if (auth.isAdmin()) return true;

  const idClient = Number(route.params['idClient']);
  if (!idClient) {
    toastrService.error('You do not have access to the information of this client', 'Access Error');
    return false;
  }

  return dataService.getCliente(idClient).pipe(
    map(client => {
      if (client.assignedTo == user.idUser) return true;
      toastrService.error('You do not have access to the information of this client', 'Access Error');
      return false;
    }),
    catchError(() => {
      toastrService.error('An error occurred while checking access to the client', 'Access Error');
      return of(false);
    })
  );
};
